"use strict";

var _classCallCheck = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_afa5e9373483510c3650f3d80edeec0c/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require("./serialization"),
    produceXMLSerialization = _require.produceXMLSerialization;

exports.implementation =
/*#__PURE__*/
function () {
  function XMLSerializerImpl() {
    _classCallCheck(this, XMLSerializerImpl);
  }

  _createClass(XMLSerializerImpl, [{
    key: "serializeToString",
    value: function serializeToString(root) {
      return produceXMLSerialization(root, false);
    }
  }]);

  return XMLSerializerImpl;
}();